import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IDoor {
  id: string;
  creatorId: number;
  createdAt: string;
  name: string;
  status: number;
  regionId: number;
}

export class IDoorResponse {
  @Type(() => IDoor)
  result: IDoor;
}

export class IDoorListResponse extends IPagination {
  @Type(() => IDoor)
  results: IDoor[];
}

export class IDoorQueryDto extends IQueryPaginationDto {
  id?: string;
  regionId?: number;
  name?: string;
}

export class IDoorPostDto {
  creatorId: number;
  name: string;
  status: number;
  regionId: number;
}

export class IDoorPatchDto {
  creatorId?: number;
  name?: string;
  status?: number;
  regionId?: number;
}
